export enum ActionType {
  GET_USER_INFO = 'GET_USER_INFO',
  GET_USER_INFO_REJECTED = 'GET_USER_INFO_REJECTED',
  GET_USER_INFO_FULFILLED = 'GET_USER_INFO_FULFILLED',
  LOGOUT = 'LOGOUT',
  LOGOUT_REJECTED = 'LOGOUT_REJECTED',
  LOGOUT_FULFILLED = 'LOGOUT_FULFILLED',
  RESET_LOGIN_ERROR = 'RESET_LOGIN_ERROR',
  UPDATE_WARNING_TIME = 'UPDATE_WARNING_TIME',
  UPDATE_WARNING_TIME_FULFILLED = 'UPDATE_WARNING_TIME_FULFILLED',
  UPDATE_WARNING_TIME_REJECTED = 'UPDATE_WARNING_TIME_REJECTED',
}
export default ActionType;
